var exports = {
  "nz": "xaee3c4fa--637bbd--card-wrapper",
  "$U": "xaee3c4fa--637bbd--headnote",
  "o5": "xaee3c4fa--637bbd--content-wrapper",
  "q3": "xaee3c4fa--637bbd--_has-image",
  "kZ": "xaee3c4fa--637bbd--image-wrapper",
  "DD": "xaee3c4fa--637bbd--title",
  "VA": "xaee3c4fa--637bbd--subtitle",
  "Nf": "xaee3c4fa--637bbd--footnote-wrapper",
  "xA": "xaee3c4fa--637bbd--footnote",
  "Rl": "xaee3c4fa--637bbd--date-publish",
  "nb": "xaee3c4fa--637bbd--status-wrapper",
};

module.exports = exports;
